"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableNoResults = void 0;
var _react = _interopRequireDefault(require("react"));
var _receiptOutlined = require("../../../assets/icons/receipt-outlined.svg");
var _tableNoResultsModule = _interopRequireDefault(require("./table-no-results.module.scss"));
var TableNoResults = function TableNoResults(_ref) {
  var header = _ref.header,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("tr", {
    className: _tableNoResultsModule.default['table-no-results'],
    "data-testid": "no-results"
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: _tableNoResultsModule.default['table-no-results__container']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _tableNoResultsModule.default['table-no-results__icon-container']
  }, /*#__PURE__*/_react.default.createElement(_receiptOutlined.ReactComponent, null)), /*#__PURE__*/_react.default.createElement("h1", {
    className: _tableNoResultsModule.default['table-no-results__header']
  }, header), /*#__PURE__*/_react.default.createElement("div", {
    className: _tableNoResultsModule.default['table-no-results__body']
  }, children)));
};
exports.TableNoResults = TableNoResults;